import type {SectionContentItem} from '../types';

import DetailsSubSection from '../components/details-sub-section';
import type {AccordionPageSection} from '@/components/accordion-page';

const SECTIONS_TYPES = {
  CORRESPONDENCE_ADDRESS: 'correspondence-address',
  CONTACT_DETAILS: 'contact-details',
  RETURNS_ADDRESS: 'returns-address',
  PAYMENT_REMITTANCE_ADDRESS: 'payment-remittance-address',
  CANADIAN_PAYMENT_REMITTANCE_ADDRESS: 'canadian-payment-remittance-address',
};

const SECTIONS_CONTENT = {
  [SECTIONS_TYPES.CORRESPONDENCE_ADDRESS]: [
    {
      subHeading: 'Primary Address',
      values: [
        {value: 'MPS', label: 'Name'},
        {value: '16365 James Madison Highway', label: 'Address'},
        {value: 'Gordonsville, VA 22942', label: 'Location'},
      ],
    },
  ],
  [SECTIONS_TYPES.CONTACT_DETAILS]: [
    {
      subHeading: 'Order Entry',
      values: [
        {value: '888-330-8477', label: 'Telephone Numbers'},
        {value: '540-672-7600', label: 'Telephone Numbers'},
        {value: '800-672-2054', label: 'Fax Numbers'},
        {value: '540-672-7542', label: 'Fax Numbers'},
        {value: 'orders@mpsvirginia.com', label: 'E-mail'},
      ],
    },
    {
      subHeading: 'Customer Service',
      values: [
        {value: '888-330-8477', label: 'Telephone Numbers'},
        {value: '540-672-7600', label: 'Telephone Numbers'},
        {value: '540-672-7703', label: 'Fax Numbers'},
        {value: 'customerservice@mpsvirginia.com', label: 'E-mail'},
      ],
    },
    {
      subHeading: 'New Accounts',
      values: [
        {value: '888-330-8477', label: 'Telephone Numbers'},
        {value: '540-672-7600', label: 'Telephone Numbers'},
        {value: '800-672-2054', label: 'Fax Numbers'},
        {value: 'actinfo@mpsvirginia.com', label: 'E-mail'},
      ],
    },
    {
      subHeading: 'Credit Department',
      values: [
        {value: '888-330-8477', label: 'Telephone Numbers'},
        {value: '540-672-7600', label: 'Telephone Numbers'},
        {value: '540-672-7540', label: 'Fax Numbers'},
      ],
    },
  ],
  [SECTIONS_TYPES.RETURNS_ADDRESS]: [
    {
      subHeading: 'Stripped Covers',
      values: [
        {value: 'MPS Stripped Cover Returns', label: 'Return Type'},
        {value: 'MPS Returns Center', label: 'Facility Name'},
        {value: '14299 Litchfield Drive', label: 'Street Address'},
        {value: 'Orange, VA 22960', label: 'City, State, ZIP'},
      ],
    },
    {
      subHeading: 'Hardcover and Trade Paperback',
      values: [
        {value: 'MPS', label: 'Facility Name'},
        {value: '14301 Litchfield Drive', label: 'Street Address'},
        {value: 'Orange, VA 22960', label: 'City, State, ZIP'},
      ],
    },
    {
      subHeading: 'Mass Market - Mint Carton (Full Case)',
      values: [
        {value: 'MPS', label: 'Facility Name'},
        {value: 'c/o Quebecor World', label: 'Handling Entity'},
        {value: 'Attn: Returns Department', label: 'Department'},
        {value: '100 U.S. Bypass 60', label: 'Street Address'},
        {value: 'Versailles, KY 40384', label: 'City, State, ZIP'},
      ],
    },
  ],
  [SECTIONS_TYPES.PAYMENT_REMITTANCE_ADDRESS]: [
    {
      subHeading: 'Remittance Address',
      values: [
        {
          value: 'Macmillan Holdings LLC - Holtzbrinck Publishers LLC',
          label: 'Facility Name',
        },
        {
          value: `DEPT CH 17571
ATTN: 10306000`,
          label: 'Mailing Address',
        },
        {value: 'Palatine, IL 60055-7571', label: 'City, State, ZIP'},
      ],
    },
    {
      subHeading: 'Tax Identification',
      values: [{value: '134047598', label: 'Federal Tax ID'}],
    },
    {
      subHeading: 'Standard Address Number (SAN)',
      values: [{value: '6315011', label: 'SAN Number'}],
    },
  ],
  [SECTIONS_TYPES.CANADIAN_PAYMENT_REMITTANCE_ADDRESS]: [
    {
      subHeading: 'Payments in CAD made payable to MPS ',
      values: [
        {
          value: `Bank of America, National Association, Canada Branch
Macmillan Holdings, LLC
C/O 922200
PO BOX 4090 STN A
TORONTO, ON M5W 0E9`,
          label: 'Address',
        },
      ],
    },
    {
      subHeading: 'Tax Identification',
      values: [
        {
          value: 'GST/HARMONIZED SALES TAX REGISTRATION - 84683 7524 RT0001',
          label: 'GST/HST Registration Number',
        },
        {
          value: 'HPLLC QST (Quebec Sales Tax) number - NR00005614',
          label: 'Quebec Sales Tax (QST) Number',
        },
      ],
    },
    {
      subHeading: 'Standard Address Number (SAN)',
      values: [{value: '6315011', label: 'SAN Number'}],
    },
  ],
};

export const SECTIONS: Record<
  string,
  AccordionPageSection<SectionContentItem>
> = {
  [SECTIONS_TYPES.CORRESPONDENCE_ADDRESS]: {
    title: 'Correspondence Address',
    iconClassName: 'fa-envelope',
    className: 'Correspondence-address',
    component: DetailsSubSection,
    contents: SECTIONS_CONTENT[SECTIONS_TYPES.CORRESPONDENCE_ADDRESS],
  },
  [SECTIONS_TYPES.CONTACT_DETAILS]: {
    title: 'Contact Details',
    iconClassName: 'fa-phone',
    className: 'Contact-details',
    component: DetailsSubSection,
    contents: SECTIONS_CONTENT[SECTIONS_TYPES.CONTACT_DETAILS],
  },
  [SECTIONS_TYPES.RETURNS_ADDRESS]: {
    title: 'Returns Address',
    iconClassName: 'fa-truck',
    className: 'Returns-address',
    component: DetailsSubSection,
    contents: SECTIONS_CONTENT[SECTIONS_TYPES.RETURNS_ADDRESS],
  },
  [SECTIONS_TYPES.PAYMENT_REMITTANCE_ADDRESS]: {
    title: 'Payment & Tax Information',
    iconClassName: 'fa-file-invoice-dollar',
    className: 'Payment-remittance-address',
    component: DetailsSubSection,
    contents: SECTIONS_CONTENT[SECTIONS_TYPES.PAYMENT_REMITTANCE_ADDRESS],
  },
  [SECTIONS_TYPES.CANADIAN_PAYMENT_REMITTANCE_ADDRESS]: {
    title: 'Canadian Payment & Tax Information',
    iconClassName: 'fa-file-contract',
    className: 'Canadian-payment-remittance-address',
    component: DetailsSubSection,
    contents:
      SECTIONS_CONTENT[SECTIONS_TYPES.CANADIAN_PAYMENT_REMITTANCE_ADDRESS],
  },
};
